<template>
    <Modal id="modalLogin" title="Login">
        <p class="mb-3 font-bold">Welcome to Glory or Died (GOD)</p>
        <Form @onSubmit="login">
            <Input label="Email ..." v-model="email" />
            <Input type="password" label="Password ..." v-model="password" />
            <Button type="submit" class="w-full !mx-0">LOGIN</Button>
        </Form>
    </Modal>
</template>

<script>
import Button from '@/components/noc_ui/Button.vue'
import Form from '@/components/noc_ui/XForm.vue'
import Input from '@/components/noc_ui/Input.vue'
import Modal from '@/components/noc_ui/Modal.vue'

export default {
    components: {
        Button,
        Form,
        Input,
        Modal
    },
    data() {
        return {
            email: '',
            password: ''
        }
    },
    methods: {
        async login() {
            this.$loading.is = true
            const { data, error } = await this.$supabase.auth.signInWithPassword({
                email: this.email,
                password: this.password
            });

            if (error) {
                this.errorMessage = error.message;
            } else {
                console.log('User:', data.user);
                window.location.reload()
            }

            this.$loading.is = false
        }
    }
}
</script>